import React from 'react';
import Footer from '../../components/Layout/Footer';
import SearchModal from '../../components/Layout/Header/SearchModal';
import SiteBreadcrumb from '../../components/Common/Breadcumb';
//import ServiceOneMain from '../../components/ServiceOne/ServiceOneMain';

// Breadcrumbs Background Image
import bannerbg from '../../assets/img/bg/tech-bg.png';
import DetailsHeader from '../../components/Layout/Header/DetailsHeader';
import CorporateLegacy from '../sections/CorporateLegacy';


const Services = () => {

    return (
        <React.Fragment>

            <DetailsHeader
              parentMenu='page'
              secondParentMenu='service'
              activeMenu='/service'
            />
            <div>
                {/* breadcrumb-area-start */}
                <SiteBreadcrumb
                    pageTitle="Services"
                    titleClass="page-title"
                    pageName="Services"
                    breadcrumbsImg={bannerbg}
                />
                {/* breadcrumb-area-start */}

                {/* ServiceOneMain */}
                {/* Capabilities / Legacy */}
                <CorporateLegacy />
                {/* ServiceOneMain */}
            </div>
            <Footer />
            <SearchModal />
        </React.Fragment>

    );
}


export default Services;